import React from "react";
import { ReactComponent as PointIcon } from "../../../../assets/svg/icons/point.svg";
import { StaticMapRender } from "../../../EditOnboarding/Components/StaticMapRender/Index";
import { DropdownV2 } from "../../../FormControlsV2";
import { StandardPastureTaskFiltersProps } from "./types";
import { useTranslation } from "react-i18next";

export function StandardPastureTaskFilters({
  farmOptions,
  currentFarm,
  onFarmChange,
  farmLabel,
  areaOptions,
  currentArea,
  onAreaChange,
  areaLabel,
  responsibleOptions,
  currentResponsible,
  onResponsibleChange,
  microAreaOptions,
  currentMicroArea,
  onMicroAreaChange,
  fitCoords,
  drawCoords,
  allMicroAreas,
  farmOutlineCoords,
  onMapMicroAreaSelected,
}: StandardPastureTaskFiltersProps) {
  const { t } = useTranslation();
  return (
    <>
      <div className="filters-container filters-wrap">
        <div className="filters-dropdown">
          <DropdownV2
            name="create-task-farm"
            placeholder={t("taskCreation.farm")}
            options={farmOptions}
            value={currentFarm ?? null}
            menuMount="overlay"
            onChange={(opt) => onFarmChange(opt?.value)}
          />
        </div>
        <div className="filters-dropdown">
          <DropdownV2
            name="create-task-area"
            placeholder={t("taskCreation.area")}
            options={areaOptions}
            value={currentArea ?? null}
            menuMount="overlay"
            onChange={(opt) => onAreaChange(opt?.value)}
          />
        </div>
        <div className="filters-dropdown">
          <DropdownV2
            name="create-task-responsible-inline"
            placeholder={t("taskCreation.responsible")}
            options={responsibleOptions}
            value={currentResponsible ?? null}
            menuMount="overlay"
            onChange={(opt) => onResponsibleChange(opt)}
          />
        </div>
        <div className="filters-dropdown">
          <DropdownV2
            name="create-task-micro-area"
            placeholder={t("taskCreation.paddock")}
            searchable
            options={microAreaOptions}
            value={currentMicroArea ?? null}
            menuMount="overlay"
            onChange={(opt) => onMicroAreaChange(opt?.value)}
          />
        </div>
      </div>
      <div className="pasture-container">
        {!(fitCoords.length > 0) ? (
          <PointIcon />
        ) : (
          <StaticMapRender
            farm={farmOutlineCoords}
            mainPolygon={drawCoords || []}
            microAreas={
              allMicroAreas
                ? allMicroAreas
                  .filter((micro) =>
                    currentArea ? micro.area_id == currentArea?.value : true,
                  )
                  .map((micro) => micro.map_coords || [])
                : []
            }
            fitCoords={fitCoords}
            allMicroAreas={
              allMicroAreas
                ? allMicroAreas.filter((micro) =>
                  currentArea ? micro.area_id == currentArea?.value : true,
                )
                : []
            }
            setMicroAreaSelected={onMapMicroAreaSelected}
          />
        )}
      </div>
    </>
  );
}
